import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Breadcrumb, GenerateTableColumn, GenerateTablePageEvent, GenerateTablePagination } from 'src/app/shared/components';
import { Alocacao, AlocacaoService, Contrato, ContratoService } from 'src/app/contrato';
import { Beneficiaria, BeneficiariaService } from 'src/app/beneficiaria';
import { catchErr } from 'src/app/shared/utils';
import dayjs from 'dayjs';
import { RelatorioService } from '../relatorio.service';
import { Dio } from 'src/app/dio/dio.model';
import { Equipamento } from 'src/app/equipamento';
import { GenericRelatorioComponent } from '../generic-relatorio.component';
import { dataAtualString, primeiroDiaDoMesString } from 'src/app/shared/date-utils';

@Component({
    selector: 'app-dios-por-prefixo',
    templateUrl: './dios-por-prefixo.component.html',
    standalone: false
})
export class DiosPorPrefixoComponent extends GenericRelatorioComponent implements OnInit {

    breadcrumb: Breadcrumb[] = [
        { label: 'Início' },
        { label: 'Relatórios', route: '/relatorio' },
        { label: 'DIO\'s Por Prefixo' },
    ]

    dataSource: any[];
    alocacoes: Alocacao[] = [];
    pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 };
    columns: GenerateTableColumn[] = [
        { header: 'Data Operação', attr: 'dataOperacao' },
        { header: 'N° DIO', attr: 'numero' },        
        { header: 'Hora Disponível', attr: 'horasDisponiveis' },
        { header: 'Hora Trabalhada', attr: 'horasTrabalhadas' },
        { header: 'Km Rodados', attr: 'kmRodados' },
        { header: 'Status', attr: 'status' },
        
    ];

    constructor(
        private relatorioService: RelatorioService,
        protected override beneficiariaService: BeneficiariaService,
        protected alocacaoService: AlocacaoService,
        protected override snackBar: MatSnackBar,
    ) {
        super(beneficiariaService, snackBar);
    }

    ngOnInit() {
        this.toggleFilters = true;
        this.beneficiariaService.getAll<Beneficiaria>().subscribe({
            next: (res) => this.beneficiarias = res.data,
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);

        this.filters.dataInicio = primeiroDiaDoMesString();
        this.filters.dataFim = dataAtualString();

        this.search();
    }

    search(pageEvent?: GenerateTablePageEvent) {
        this.loading = true;
        this.pagination.current = pageEvent ? pageEvent.current : this.pagination.current
        this.pagination.pageSize = pageEvent ? pageEvent.pageSize : this.pagination.pageSize

        const filters = { ...this.filters };
        filters.dataInicio = filters.dataInicio ? `${dayjs(filters.dataInicio).format('YYYY-MM-DD')}` : filters.dataInicio;
        filters.dataFim = filters.dataFim ? `${dayjs(filters.dataFim).format('YYYY-MM-DD')}` : filters.dataFim;
        filters.alocacao = undefined;
        filters.beneficiaria = undefined;
        filters.contrato = undefined;

        this.relatorioService.getRelatorioDiosPorPrefixos(filters, this.pagination.current, this.pagination.pageSize).subscribe({
            next: (res: any) => {
                if (res.report.data) {
                    this.dataSource = res.report.data.map((item: any) => this.buildResponse(item));
                    this.pagination.total = parseInt(res.report.total) || res.report.data.length;
                }
            }
        }).add(() => this.loading = false);
    }

    setBeneficiaria(beneficiaria: Beneficiaria) {
        console.log('Beneficiária selecionada:', beneficiaria);
        this.filters.beneficiaria = beneficiaria;
        this.filters.contrato = undefined;

        this.beneficiariaService.getContratos(beneficiaria.id!).subscribe({
            next: (res) => this.contratos = res,
            error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    setContrato(contrato: Contrato) {
        this.alocacaoService.getAll(contrato.id).subscribe({
            next: (res) => this.alocacoes = res.data as Alocacao[],
            error: (err) => catchErr(err, this.snackBar)
        });
    }

    setAlocacao(alocacao: Alocacao) {
        this.filters.prefixo = alocacao.codigo;                
    }

    buildResponse(item: any) {        
        let status = item.statusExecucao;

        if(item.statusAfericao){
            status += ` - ${item.statusAfericao}`;
        }

        return {
            numero: item.numero,
            dataOperacao: item.dataOperacao,
            horasDisponiveis: item.horasDisponiveis || '00:00',
            horasTrabalhadas: item.horasTrabalhadas || '00:00',
            kmRodados: item.kmRodados || '0',
            prefixo: item.prefixo,            
            status: status,
            created_at: dayjs(item.created_at).format('DD/MM/YYYY HH:mm:ss'),
        }
    }

    export(type: string = 'csv') {
        this.loading = true;

        const filters = { ...this.filters, removePaingation: true };
        filters.dataInicio = filters.dataInicio ? `${dayjs(filters.dataInicio).format('YYYY-MM-DD')}T00:00:00` : filters.dataInicio;
        filters.dataFim = filters.dataFim ? `${dayjs(filters.dataFim).format('YYYY-MM-DD')}T23:59:59` : filters.dataFim;

        this.relatorioService.downloadArquivoCsvOrPdf(filters, 'dios-nao-executados', type).subscribe({
            next: (res: any) => {
                const url = window.URL.createObjectURL(res.body as Blob);
                const startReport = filters.dataInicio ? dayjs(filters.dataInicio).format('DD-MM-YYYY') : dayjs().format('DD-MM-YYYY')
                const endReport = filters.dataFim ? dayjs(filters.dataFim).format('DD-MM-YYYY') : dayjs().format('DD-MM-YYYY')
                const fileName = `Dios_nao_executados_${startReport}_${endReport}`
                const anchor = document.createElement("a");
                anchor.download = `${fileName}.${type}`;
                anchor.href = url;
                anchor.click();
                this.toggleFilters = false;
                this.loading = false;
            }, error: (err) => console.log('err', err)
        });
    }

}
